import { z } from 'zod'
import { religionSchema } from './employee.js'

export const publicHolidaySchema = z.object({
  date: z.string().date(),
  name: z.string(),
  region: z.string().default('MY-FED'),
  tentative: z.boolean().default(false),
  // Informational HR-facing label (null when not religion-specific). Optional
  // in TS so fixtures/story data created before it was surfaced still compile.
  religion: religionSchema.nullable().optional(),
})

export type PublicHoliday = z.infer<typeof publicHolidaySchema>

export const publicHolidayCreateSchema = z.object({
  date: z.string().date(),
  region: z.string().min(1).max(16).default('MY-FED'),
  name: z.string().min(1).max(200),
  tentative: z.boolean().default(false),
  religion: religionSchema.nullable().default(null),
})

export type PublicHolidayCreate = z.infer<typeof publicHolidayCreateSchema>

export const publicHolidayUpdateSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  tentative: z.boolean().optional(),
  religion: religionSchema.nullable().optional(),
})

export type PublicHolidayUpdate = z.infer<typeof publicHolidayUpdateSchema>
